<template>
<div class="Card">
    <!-- <div v-if="cardType === 'app'"> -->
    <!--        /{{cardClass}}/{{cardType}}-->
    <!--        <pre>{{ content | json }}</pre>-->
    <div v-if="['Video1', 'Podcast1'].includes(cardType) || cardClass === 'Product'"
         :class="cardClass">
        <div class="tile__s__linkWrapp">
            <div class="tile__s__head">
                <div v-if="isFrozen" class="frozen-overlay" title="This product is not currently available.">
                    <div>Deactivated</div>
                </div>
                <video-content
                    v-if="cardType === 'Video'"
                    :content="content" />
                <podcast-content
                    v-if="cardType === 'Podcast'"
                    :content="content" />
                <a
                    :href="cardPath"
                    target="_blank">
                    <button
                        v-if="showBuyBtn"
                        class="tile__s__buyBtn"
                        @click.prevent="addToCard">
                        {{ $t('CARD.BUY_TITLE') }}
                    </button>
                </a>
            </div>
            <a
                :href="cardPath"
                :target="blank ? '_blank' : '_self'"
                class="tile__s__body"
                @click.prevent="openCard">
                <div class="tile__s__title">
                    <div>{{ cardType }}</div>
                    <div
                        v-if="content.class_name === 'Product' && content.pricings[0]"
                        class="text__right">
                        <div>{{ `${content.pricings[0].title} $${content.pricings[0].price}` }} {{ context.pricings[1] ? '/': '' }}</div>
                        <div>{{ context.pricings[1] ? `${content.pricings[1].title} $${content.pricings[1].price}` : '' }}</div>
                    </div>
                </div>
                <div
                    ref="tooltipContainer"
                    v-tooltip="tooltipContent"
                    class="tile__s__name text__ellipsis__2row">{{ slicedTitle }}</div>
            </a>
        </div>
        <div class="tile__s__footer">
            <!-- <a
                v-tooltip="{ content: $t('TOOLTIP.ELEVATE'), placement: 'bottom' }"
                href="#"
                :disabled="loading || isFrozen"
                class="tile__s__elevate"
                @click.prevent="handleContentLike">
                <i
                    class="icon-elevate"
                    :class="{'active': isElevatedActive }" />
            </a> -->
            <!-- <a
                href="#"
                :disabled="loading"
                @click.prevent="content.class_name === 'Product' ? openProductTallyModal(content.id) : openCardTallyModal(content.id)">
                <span class="link-elevation-count">{{ elevatesCount }}</span>
            </a> -->
            <a
                v-if="!is_private_group"
                href="#"
                class="tile__s__share"
                :disabled="isFrozen"
                @click.prevent="openShareModal">
                <i class="icon-share" />
            </a>
        </div>
    </div>
    <div v-else-if="cardType !== 'Irregular'" :class="cardClass">
        <div class="card-header">
            <div class="header-left">
                <img src="~@assets/imgs/events/note.svg" alt="Card">
                <span class="collection-text">Card 
                    <span>({{ cardType }})</span>
                </span>
            </div>
            <!-- <div class="header-right">
                <img src="~@assets/imgs/events/dots-icon.svg" class="icon-img" alt="more">
            </div> -->
        </div>

        <div class="card-body">
            <!-- <div class="user-section">
                <div class="user-info">
                    <img :src="content.owner.avatar" class="avatar" alt="user">
                    <div class="user-meta">
                        <p class="user-name"> {{ capitalizedOwnerName }} </p>
                        <p class="post-date">{{ moment(content.created_at).format('MMM D, YYYY') }}
                            <img src="~@assets/imgs/events/privacy-connections.png" class="small-icon" alt="private">
                        </p>
                    </div>
                </div>
            </div> -->

            <a
            :href="cardPath"
            :target="blank ? '_blank' : '_self'"
            class="tile__s__linkWrapp">
            
                <div class="row g-2 thumbnail-grid">
                    <div class="col-12">
                        <div class="thumb-wrapper">
                            <VideoContent v-if="cardType === 'Video'" :content="content" />
                            <PodcastContent v-else-if="cardType === 'Podcast'" :content="content" />
                            <img v-else :src="imgUrl" class="thumb-img" alt="" />
                        </div>
                    </div>
                </div>

                <div class="card-content">
                    <h3
                        ref="tooltipContainer"
                        v-tooltip="tooltipContent" 
                        class="card-title">
                        {{ slicedTitle }}
                    </h3>

                    <p class="card-description">
                        {{ truncate(content.description, 120) }}
                    </p>
                </div>
            </a>

            <div class="card-footer">
                <button class="footer-btn" @click.prevent="openSaveModal(content)" >
                    <img src="~@assets/imgs/events/save.svg" class="icon-img" alt="save" >
                    Save ({{ content.saves_count || 0 }})
                </button>

                <button v-if="canShareCard" class="footer-btn" @click.prevent="openShareModal(content)" >
                    <img src="~@assets/imgs/events/export.svg" class="icon-img" alt="share" >
                    Share ({{ content.shares_count || 0 }})
                </button>
            </div>
        </div>
    </div>
    <div v-else-if="cardClass === 'CardCollection'" :class="cardClass">
        <div class="card-header">
            <div class="header-left">
                <img src="~@assets/imgs/events/note.svg" alt="Collection">
                <span class="collection-text">Collection 
                    <span>({{ content.total_card }} {{ content.total_card === 1 ? 'card' : 'cards' }})</span>
                </span>
            </div>
            <div class="header-right">
                <img @click.stop="toggleCollectionDropdown(content.id)" src="~@assets/imgs/events/more.svg" class="icon-img" alt="more">
                <DropDown 
                    v-if="showCollectionDropdown === content.id" 
                    v-click-outside="closeCollectionDropdown"
                    ref="dropdown"
                    :items="dropdownCollectionContent(content)"
                    @clicked="(item) => { handleDropdownCollectionClick(item, content); showCollectionDropdown = null }" 
                />
            </div>
        </div>

        <div class="card-body">
            <!-- <div class="user-section"> -->
                <!-- <div class="user-info">
                    <img :src="content.owner.avatar" class="avatar" alt="user">
                    <div class="user-meta">
                        <p class="user-name"> {{ capitalizedOwnerName }} </p>
                        <p class="post-date">{{ moment(content.created_at).format('MMM D, YYYY') }}
                            <img 
                                :src="getPrivacyIcon(content.privacy)" 
                                :title="content.privacy.charAt(0).toUpperCase() + content.privacy.slice(1)"
                                class="small-icon" 
                                alt="privacy"
                            >
                        </p>
                    </div>
                </div>
                <div class="update-meta">
                    <p class="update-label">Last updated on:</p>
                    <p class="update-date"> {{ moment(content.updated_at).format('MMM D, YYYY') }} </p>
                </div> -->
                <!-- <div class="card-content">
                    <h3 class="card-title">
                        {{ content.name }}
                    </h3>

                    <p class="card-description">
                        {{ truncate(content.description, 120) }}
                    </p>
                </div> -->
            <!-- </div> -->

            <a
            :href="cardPath"
            class="tile__s__linkWrapp"
            :target="blank ? '_blank' : '_self'"
            @click.prevent="openCard">

                <div class="row g-2 thumbnail-grid">
                    <!-- 0 cards -->
                    <template v-if="content.total_card === 0">
                        <div class="collection-img0">
                            <div class="col-12">
                                <div class="thumb-wrapper">
                                    <img :src="content.default_image" class="thumb-img" alt="default" />
                                    <!-- <img :src="'https://prd-assets.sphir.io/uploads/cover/avatar/69a4a9128401f42663b0715f/-c94e07ac-e539-462b-8407-e89c5713be97'" class="thumb-img" alt="default" />  -->
                                </div>
                            </div>
                        </div>
                    </template>

                    <!-- 1 card -->
                    <template v-else-if="content.total_card === 1">
                        <div class="collection-img1">
                            <div class="col-12" v-if="content.four_cards_logo && content.four_cards_logo[0]">
                                <div class="thumb-wrapper">
                                    <img :src="content.four_cards_logo[0].logo_image" class="thumb-img" alt="" />
                                </div>
                            </div>
                        </div>
                    </template>

                    <!-- 2 cards -->
                    <template v-else-if="content.total_card === 2">
                        <div class="collection-img2">
                            <div v-for="(img, index) in (content.four_cards_logo || []).slice(0,2)" :key="index" class="col-12">
                                <div class="thumb-wrapper">
                                    <img :src="img.logo_image" class="thumb-img" alt="" />
                                </div>
                            </div>
                        </div>
                    </template>

                    <!-- 3 cards -->
                    <template v-else-if="content.total_card === 3">
                        <div class="collection-img3">
                            <div class="col-12" v-if="content.four_cards_logo && content.four_cards_logo[0]">
                                <div class="thumb-wrapper">
                                    <img :src="content.four_cards_logo[0].logo_image" class="thumb-img" alt="" />
                                </div>
                            </div>
                            <div v-for="(img, index) in (content.four_cards_logo || []).slice(1,3)" :key="index" class="col-6">
                                <div class="thumb-wrapper">
                                    <img :src="img.logo_image" class="thumb-img" alt="" />
                                </div>
                            </div>
                        </div>
                    </template>

                    <!-- 4+ cards -->
                    <template v-else>
                        <div class="collection-img4">
                            <div v-for="(img, index) in (content.four_cards_logo || []).slice(0,4)" :key="index" class="col-6">
                                <div class="thumb-wrapper">
                                    <img :src="img.logo_image" class="thumb-img" alt="" />
                                    <div v-if="index === 3 && content.total_card > 4" class="overlay">
                                        +{{ content.total_card - 4 }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>

                <div class="card-content">
                    <h3 class="card-title">
                        {{ content.name }}
                    </h3>

                    <p class="card-description">
                        {{ truncate(content.description, 120) }}
                    </p>
                </div>
            </a>
            
            <div v-if="showFooter" class="card-footer">
                <!-- <button class="footer-btn" @click.prevent="toggleSave(content)" >
                    <img src="~@assets/imgs/events/save.svg" class="icon-img" alt="save" >
                    Save ({{ content.saves_count || 0 }})
                </button> -->

                <button class="footer-btn" @click.prevent="openShareModal(content)" >
                    <img src="~@assets/imgs/events/export.svg" class="icon-img" alt="share" >
                    Share ({{ content.shares_count || 0 }})
                </button>
            </div>
        </div>
    </div>
    <div v-else-if="cardClass === 'Group'"
         :class="cardClass">
        <a
            :href="cardPath"
            class="tile__s__linkWrapp"
            :target="blank ? '_blank' : '_self'"
            @click.self="openCard">
            <div class="tile__s__headNew">
                <img
                    class="tile__s__circleImgNew"
                    :src="content.avatar">
            </div>
            <div class="tile__s__body text__center">
                <div class="tile__s__name text__ellipsis__1row tile__s__name__withMinHeight">
                    {{ slicedTitle }}
                </div>
                <div class="tile__s__status color__secondary_40 text__bold fs__12">
                    {{ content.group_privacy_type }}
                </div>
                <div class="tile__s__actionInfo text__bold fs__12">
                    <span>{{ $tc('CARD.FOLDER_COUNT', content.group_folder_count, { count: content.group_folder_count }) }}</span>
                    <span>{{ $tc('CARD.FOLLOWER_COUNT', content.followers_count, { count: content.followers_count }) }}</span>
                    <span>{{ $tc('CARD.MEMBER_COUNT', content.members_count, { count: content.members_count }) }}</span>
                </div>
                <div
                    v-if="currentUser"
                    class="tile__s__action">
                    <button
                        :disabled="loading"
                        @click.prevent="handleFollow">
                        <i
                            class="icon-follow"
                            :class="{'active': content.is_following || content.is_joined}">
                            <span class="path1" /><span class="path2" /><span class="path3" /><span class="path4" /><span class="path5" /><span class="path6" /><span class="path7" /><span class="path8" />
                        </i>
                    </button>
                    <button
                        :disabled="loading"
                        @click.prevent="handleJoin">
                        <i
                            class="icon-add-a-friend"
                            :class="{'active': content.is_joined}" />
                    </button>
                </div>
            </div>
        </a>
        <div class="tile__s__footer">
            <!-- <button
                v-tooltip="{ content: $t('TOOLTIP.ELEVATE'), placement: 'bottom' }"
                href="#"
                :disabled="loading"
                class="tile__s__elevate btn__reset"
                @click.prevent="toggleGroupElevation">
                <i
                    class="icon-elevate"
                    :class="{'active': isElevatedActive}" />
            </button>
            <a
                href="#"
                :disabled="loading"
                @click.prevent="openGroupTallyModal(content.id)">
                <span class="link-elevation-count">{{ elevatesCount }}</span>
            </a> -->
            <a
                href="#"
                class="tile__s__share"
                @click.prevent="openShareModal">
                <i class="icon-share" />
            </a>
        </div>
    </div>
    <div v-else-if="cardClass === 'User'"
         :class="cardClass">
        <a
            :href="cardPath"
            class="tile__s__linkWrapp"
            :target="blank ? '_blank' : '_self'"
            @click.self="openCard">
            <div class="tile__s__headNew">
                <img
                    class="tile__s__circleImgNew"
                    :src="content.avatar">
            </div>
            <div class="tile__s__body text__center">
                <div class="tile__s__name tile__s__name__withMinHeight">
                    {{ content.first_name }} {{ content.last_name }}
                </div>
                <!-- <div class="tile__s__status color__secondary_40 text__bold fs__12">
                        {{ content.account_type }}
                    </div> -->
                <div class="tile__s__actionInfo text__bold fs__12">
                    <span>{{ $tc('CARD.FOLDER_COUNT', content.total_folder, { count: content.total_folder }) }}</span>
                    <span>{{ $tc('CARD.FOLLOWER_COUNT', content.followed_count, { count: content.followed_count }) }}</span>
                    <span>{{ $tc('CARD.PRODUCT_COUNT', content.products_count, { count: content.products_count }) }}</span>
                </div>
                <div
                    v-if="currentUser"
                    class="tile__s__action">
                    <button
                        :disabled="loading"
                        @click.prevent="handleUserFollow">
                        <i
                            class="icon-follow"
                            :class="{'active': content.followed}">
                            <span class="path1" /><span class="path2" /><span class="path3" /><span class="path4" /><span class="path5" /><span class="path6" /><span class="path7" /><span class="path8" />
                        </i>
                    </button>
                </div>
            </div>
        </a>
        <div class="tile__s__footer">
            <!-- <a
                v-tooltip="{ content: $t('TOOLTIP.ELEVATE'), placement: 'bottom' }"
                href="#"
                :disabled="loading"
                class="tile__s__elevate"
                @click.prevent="handleUserLike">
                <i
                    class="icon-elevate"
                    :class="{'active': isElevatedActive}" />
            </a>
            <a
                href="#"
                :disabled="loading"
                @click.prevent="openUserTallyModal(content.id)">
                <span class="link-elevation-count">{{ elevatesCount }}</span>
            </a> -->
            <a
                href="#"
                class="tile__s__share"
                @click.prevent="openShareModal">
                <i class="icon-share" />
            </a>
        </div>
    </div>
    <div v-else-if="cardClass === 'TrendingTopic'"
         :class="cardClass">
        <a
            href="#"
            class="tile__s__linkWrapp"
            @click.prevent="">
            <div class="tile__s__head">
                <div class="tile__s__head__name text__uppercase fs__16 margin-b__10 margin-t__80 text__center padding-t__10">
                    {{ $t('CARD.TOPIC') }}
                </div>
                <div class="tile__s__head__title text__ellipsis__2row fs__28 color__main text__center text__bold margin-b__50">
                    {{ slicedTitle }}
                </div>
            </div>
            <div class="tile__s__body text__center">
                <div class="tile__s__action">
                    <button @click="pushTopic(content)">
                        {{ $t('CARD.FILTER_ADD') }}
                    </button>
                    <button @click.prevent="openCard">
                        {{ $t('CARD.FILTER_SEARCH') }}
                    </button>
                </div>
            </div>
        </a>
    </div>
    <div v-else-if="cardClass === 'Image'"
         :class="cardClass">
        <img
            class=""
            :src="content.avatar"
            @error="setAltImg">
    </div>
</div>
</template>

<script>
    import {mapGetters, mapActions} from "vuex";
    import VideoContent from "./VideoContent";
    import PodcastContent from "./PodcastContent";
    const DropDown = () => import('@components/Dropdown')

    export default {
        name: 'Card',
        components: {
            PodcastContent,
            VideoContent,
            DropDown
        },
        props: {
            content: {type: Object, default: () => {}},
            isGroup: {type: Boolean, default: false},
            canShareCard: {type: Boolean, default: false},
            isProfile: {type: Boolean, default: false},
            blank: {type: Boolean, default: false}
        },
        data() {
            return {
                loading: false,
                upHeight: false,
                likeStatus: 'none',
                showCollectionDropdown: null
            }
        },
        computed: {
            ...mapGetters(['isSuperAdmin']),
            ...mapGetters('auth', {
                currentUser: 'getCurrentUser'
            }),
            cardClass() {
                return this.content.class_name // ['Product', 'CardNetwork', 'CardCollection', 'Group', 'User', 'TrendingTopic', 'Image']
            },
            cardType() {
                if (this.cardClass === 'Product') {
                    return this.content.category_name // ['Video', 'Podcast']
                } else if (this.cardClass === 'CardNetwork' || this.cardClass === 'Card') {
                    return this.content.type //['Video', 'Podcast', ...] https://i.imgur.com/rSvbIOJ.png
                } else {
                    return 'Irregular'
                }
            },
            capitalizedOwnerName() {
                if (!this.content?.owner) return ''

                const capitalize = (str) =>
                str ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase() : ''

                return `${capitalize(this.content.owner.first_name)} ${capitalize(this.content.owner.last_name)}`
            },
            elevatesCount() {
                let count = 0
                if (this.cardClass === 'Product') {
                    count = this.content.trusted_count || 0
                } else if (['CardNetwork', 'User', 'Card'].includes(this.cardClass)) {
                    count = this.content.trusteds_count || 0
                } else if (this.cardClass === 'Group') {
                  count = this.content.elevates_count || 0
                } else {
                    count = 0 // [CardCollection TrendingTopic] are not likable
                }
                return count
            },
            isElevatedActive() {
                let answer = false
                if (this.likeStatus === 'unliked') {
                    answer =  false
                } else if (this.likeStatus === 'liked') {
                    answer =  true
                } else if (['Product', 'User'].includes(this.cardClass)) {
                    answer =  this.content.trusted
                } else if (this.cardClass === 'CardNetwork') {
                    answer = this.content.card_tally_info.trusted
                } else if (this.cardClass === 'Card') {
                    answer = this.content.trusted
                } else if (this.cardClass === 'Group') {
                    answer = this.content.elevated
                } else {
                    answer = false
                }
                return answer
            },
            cardPath() {
                let path;
                const {id, name, class_name} = this.content
                if (class_name === 'Product') {
                    path = `/products/${id}`
                } else if (['CardNetwork', 'Card'].includes(class_name)) {
                    path = `/cards/${id}`
                } else if (class_name === 'Group') {
                    path = `/groups/${id}`
                } else if (class_name === 'User') {
                    path = `/users/${id}/other_profile`
                } else if (class_name === 'CardCollection') {
                    path = `/folders/${id}`
                } else if (class_name === 'TrendingTopic') {
                    path = `/users/search?key_word=${name.replace(' ', '+')}`
                }
                return path
            },
            tooltipContent() {
                return this.upHeight && this.slicedTitle ? this.slicedTitle : ''
            },
            cardUrl() {
                return window.location.origin + this.cardPath
            },
            context() {
                return this.content
            },
            slicedTitle() {
                if (this.content.title || this.content.name) {
                    return this.content.title || this.content.name
                } else {
                  return ''
                }
            },
            showBuyBtn() {
                const {content} = this;
                return content.class_name === 'Product' && content.pricings[0] && !this.isFrozen && !content.purchased && !content.rented //@no_buy.to_s.strip.length == 0 && !is_business?
            },
            imgUrl() {
                return this.content.main_image_url || this.content.logo_image || process.env.DEFAULT_IMAGE
            },
            canOpenCard() {
                return (this.currentUser || !['CardCollection', 'TrendingTopic'].includes(this.cardClass))
            },
            isFrozen() {
                return this.content.class_name === 'Product' && this.content.is_frozen
            },
            previewVideoCard() {
                if (this.cardClass === 'CardCollection') {
                    return this.content.preview_video_card
                }
            },
            showFooter() {
                if (this.cardClass === 'CardCollection') {
                    return (
                        this.content.name !== 'My Claimed Cards' &&
                        this.content.name !== 'Unfiled Cards'
                    );
                }
                return false;
            },
        },
        mounted() {
            const container = this.$refs.tooltipContainer
            const upHeight = container ? container.scrollHeight > container.offsetHeight : false
            upHeight ? this.upHeight = true : this.upHeight = false
        },
        methods: {
            ...mapActions('discover', {
                pushTopic: 'PUSH_UNACTIVE_TOPIC',
                followGroup: 'FOLLOW_GROUP',
                unfollowGroup: 'UNFOLLOW_GROUP',
                joinGroup: 'JOIN_GROUP',
                unjoinGroup: 'UNJOIN_GROUP',
                followUser: 'FOLLOW_USER',
                unfollowUser: 'UNFOLLOW_USER',
                likeGroup: 'LIKE_GROUP',
                unlikeGroup: 'UNLIKE_GROUP',
                likeUser: 'LIKE_USER',
                likeContent: 'LIKE_CONTENT',
            }),
            ...mapActions('entities/group', {
              likeGroupContent: 'LIKE_CONTENT',
            }),
            ...mapActions('entities/profile', {
              likeProfileContent: 'LIKE_CONTENT',
            }),
            ...mapActions('auth', {
                setRedirectLink: 'SET_REDIRECT_LINK'
            }),
            addToCard() {
              $(this).data('quantity', 1);
              $(this).data('product_id', this.content.id);
              $(this).data('product_pricing_id', this.content.pricings[0].id);
              var data = $(this).data()
              $.ajax({
                  method: "post",
                  url: "/temp_create.json",
                  data: {cart: data},
                  beforeSend: function(){
                    LoadingModal.showLoading();
                  },
                  success: function(data){ },
                  error: function(data){
                    const message = data.responseJSON.message[0]
                    iziToast.error({ message });
                  },
                  complete: function(data){
                    LoadingModal.hideLoading();
                  },
              }).done(function (respond) {
              });
            },
            openCard() {
                if (this.canOpenCard) {
                    window.location = this.cardPath
                } else {
                    UnauthModal.show({type: 'restricted_page', spa_modal: this.$modal})
                    this.setRedirectLink(this.cardPath)
                }
            },
            // openSaveModal() {
            //     console.log('Opening save modal with content');
            //     const modal = $(".modal-save-to-lib")
            //     modal.modal("show");

            //     modal.on('shown.bs.modal', () => {
            //         const m = $(".modal-save-to-lib.show") // active instance

            //         m.attr("data_id", this.content.id)
            //         m.find(".card-id").val(this.content.id)
            //         m.find(".locationchange").val("false")
            //         m.addClass("from_group")
            //     })
            // },
            openSaveModal() { 
                const modal = $(".modal-save-to-lib") 
                modal.attr("data_id", this.content.id) 
                modal.find(".card-id").val(this.content.id); 
                modal.find(".locationchange").val("false"); 
                modal.addClass("from_group"); 
                
                modal.modal("show");
            },
            openShareModal(e) {
                if (this.isFrozen) {
                  iziToast.error({message: 'This product is not currently available.'});
                } else if (!this.currentUser) {
                    UnauthModal.show({type: 'restricted_share', spa_modal: this.$modal})
                    this.setRedirectLink(this.cardPath)
                } else if (ShareModal) {
                    $('.save-to-my-lib').hide()
                    $('.save-to-my-lib-separate').hide()
                    ShareModal.show({...this.content, url: this.cardUrl, current_user_id: (this.currentUser || {}).id, spa_modal: this.$modal})
                }
            },
            openCardTallyModal(id) {
              $.ajax({
                method: "get",
                url: "/cards/load_tally_data/" + id,
              });
            },
            openGroupTallyModal(id) {
              $.ajax({
                method: "get",
                url: "/groups/tally_group_elevate?group_id=" + id,
              });
            },
            openUserTallyModal(id) {
              $.ajax({
                method: "get",
                url: "/users/load_profile_tally_info/" + id,
              });
            },
            openProductTallyModal(id) {
              $.ajax({
                method: "get",
                url: "/products/load_tally_data/" + id,
              });
            },
            openVideoPreviewModal(previewVideoCard) {
                this.$modal.show('collection-video-preview', { previewVideoCard });
            },
            async handleUserFollow() {
                this.loading = true
                const data = {
                    user_id: this.content.id
                }
                if (!this.content.followed) {
                    await this.followUser(data)
                } else {
                    await this.unfollowUser(data)
                }
                this.loading = false
            },
            async handleContentLike() {
                if (this.isFrozen) {
                    iziToast.error({message: 'This product is not currently available.'});
                } else {
                    this.loading = true
                    const data = {
                        domain: process.env.API_CLIENT,
                        resource_id: this.content.id,
                        resource_name: this.cardClass
                    }
                    try {
                    let response
                      if (this.isGroup || this.isProfile) {
                        data.resource_name = 'CardNetwork'
                        data.resource_id = this.content.card_network_id
                        if (this.isGroup) {
                          response = await this.likeGroupContent(data)
                        }
                        if (this.isProfile) {
                          response = await this.likeProfileContent(data)
                        }
                      } else {
                        response = await this.likeContent(data)
                      }
                      if (response.data.response.message.includes('unelevated') && this.likeStatus === 'liked' || this.likeStatus === 'unliked') {
                          this.likeStatus = 'toggle'
                      } else if (response.data.response.message.includes('unelevated') && this.likeStatus !== 'liked') {
                        this.likeStatus = 'unliked'
                      } else if (response.data.response.message.includes('been elevated') && this.likeStatus !== 'unliked') {
                        this.likeStatus = 'liked'
                      }
                    } catch (e) {
                      iziToast.error({message: 'Please, sign in to elevate.'});
                    }
                    this.loading = false
                }
            },
            async handleFollow() {
                this.loading = true
                const data = {
                    user_id: this.currentUser.id,
                    group_id: this.content.id
                }
                if (!this.content.is_following) {
                    await this.followGroup(data)
                } else {
                    await this.unfollowGroup(data)
                }
                this.loading = false
            },
            async handleJoin() {
                this.loading = true
                const data = {
                    user_id: this.currentUser.id,
                    group_id: this.content.id
                }
                if (!this.content.is_joined) {
                    await this.joinGroup(data)
                } else {
                    await this.unjoinGroup(data)
                }
                this.loading = false
            },
            async toggleGroupElevation () {
                this.loading = true
                const data = {
                  group_id: this.content.id
                }
                if (!this.content.elevated) {
                  await this.likeGroup(data)
                } else {
                  await this.unlikeGroup(data)
                }
                this.loading = false
            },
            async handleUserLike() {
                this.loading = true
                const data = {
                    domain: process.env.API_CLIENT,
                    user_id: this.content.id
                }
                await this.likeUser(data)
                this.loading = false
            },
            setAltImg(event){
                event.target.src = process.env.DEFAULT_IMAGE
            },
            truncate(text, length) {
                if (!text) return ''
                if (text.length <= length) return text

                const truncated = text.substring(0, length)
                return truncated.substring(0, truncated.lastIndexOf(' ')) + '...'
            },
            getColClass(total, index) {
                // 1 image => full width
                if (total === 1) return 'col-12';
                // 2 images => two halves
                if (total === 2) return 'col-6';
                // 3 images => top 1 full, bottom 2 half
                if (total === 3) return index === 0 ? 'col-12' : 'col-6';
                // 4 or more => grid of 4
                return 'col-6';
            },
            getPrivacyIcon(privacy) {
                switch (privacy) {
                    case 'public':
                        return require('@assets/imgs/events/privacy-public.png');
                    case 'friends':
                        return require('@assets/imgs/events/privacy-connections.png');
                    case 'private':
                        return require('@assets/imgs/events/privacy-secret.png');
                    default:
                        return require('@assets/imgs/events/privacy-public.png');
                }
            },
            toggleCollectionDropdown(collection_id) {
                this.showCollectionDropdown = this.showCollectionDropdown === collection_id ? null : collection_id
            },
            dropdownCollectionContent(collection) {
                if (this.isSuperAdmin) {
                    return [
                        {
                            title: this.$t('DROPDOWN.DELETE'),
                            action: 'nostore/DELETE_COLLECTION',
                            payload: collection.id
                        }
                    ]
                }

                // if (event.is_admin) {
                //     return [
                //         {
                //             title: this.$t('DROPDOWN.EDIT'),
                //             action: 'nostore/EDIT_COLLECTION',
                //             payload: collection.id
                //         },
                //         {
                //             title: this.$t('DROPDOWN.DELETE'),
                //             action: 'nostore/DELETE_COLLECTION',
                //             payload: collection.id
                //         }
                //     ]
                // }

                // fallback (not admin, not joined)
                return [
                    {
                        title: this.$t('DROPDOWN.FLAG'),
                        action: 'nostore/FLAG_COLLECTION',
                        payload: collection.id
                    }
                ]
            },
            handleDropdownCollectionClick(item, collection) {
                switch (item.action) {
                    case 'nostore/EDIT_COLLECTION':
                        $.ajax({
                            type: 'GET',
                            url: `/folders/${collection.id}/edit`
                        });
                        break;
                    case 'nostore/DELETE_COLLECTION':
                        this.handleDeleteCollection(collection)
                        break;
                    case 'nostore/FLAG_COLLECTION':
                        window.location = `/flags/Folder/${collection.id}`
                        break;
                }
                
            },
            closeCollectionDropdown(e) {
                this.showCollectionDropdown = null
            },
            handleDeleteCollection(collection) {
                console.log('Deleting collection', collection)
                const $modal = $('.modal-confirm-delete-folder')

                $modal.find('.btn-confirm-delete').attr('href', `/folders/${collection.id}`)
                $modal.find('.purple-txt').html(collection.name)
                $modal.modal('show')
            },
        }
    }
</script>

<style lang="scss">
    .content-card {
        padding: 10px 0;
        border: 1px solid black;
    }

    .flex-end {
        justify-content: flex-end;
    }

    .icon-earth {
        position: relative;
        left: 10px;
        top: 2px;
        color: #8A7A5E;
    }

    .icon-elevate.active {
        font-weight: bold;

      &:before{
        color: #fff;
      }
    }

    .icon-follow.flex {
        display: flex;
        position: relative;
        left: 10px;

        .path2 {
            position: relative;
            right: 2px;
        }

        .path1 {
            position: relative;
            right: 10px;
        }
    }

    .tile__s__videoPreviewDisabled {
        opacity: 0.5;
    }

    .icon-video-preview {
        width: 30px;
        margin-right: 20px;
    }

    .link-elevation-count {
      font-weight: 600;
      color: #000;
      position: absolute;
      left: 6rem;
      top: 2.5rem;
    }

    .tile__s__elevate {
      padding: 0px;
    }

  .elevate-modal {
    .card-title {
      padding: 0px 30px;
    }
  }
  .Card {
    .tile__s__head {
      position: relative;
    }
    .frozen-overlay {
      position: absolute;
      top: 0;
      bottom: 0;
      width: 100%;
      background: rgba(0, 0, 0, 0.6);
      display: flex;
      align-items: center;
      z-index: 9;
      div {
        width: 100%;
        text-align: center;
        color: #fff;
        font-size: 26px;
        text-shadow: 0px 0px 2px #000000b5;
      }
    }
  }

  .user-section {
    display: flex;
    justify-content: space-between;
    margin-bottom: 12px;
    padding: 12px;
  }

    .user-info {
    display: flex;
    gap: 13px;

        .small-icon {
            width: 16px;
            height: 16px;
        }
    }

    .user-info .avatar {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    object-fit: cover;
    opacity: 1;
    }

    .user-name,
    .update-label {
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    color: #414651;
    }

    .post-date,
    .update-date {
    margin: 0;
    font-size: 12px;
    color: #717680;
    }

    .update-meta {
    text-align: right;
    }

    /* Thumbnail Styling */
    .thumbnail-grid {
        margin-bottom: 12px;
    }

    .thumb-wrapper {
        position: relative;
        overflow: hidden;
        text-align: center;
    }

    .thumb-wrapper img {
        position: relative;
        z-index: 2;
        //max-width: 90%;
        //max-height: 90%;
        height: 265px;
        object-fit: contain;
    }

    .thumb-wrapper::before {
        content: "";
        position: absolute;
        inset: 0;
        background-image: inherit;
        background-size: cover;
        background-position: center;
        filter: blur(20px);
        opacity: 0.3;
    }

    .CardCollection {
        .card-body {
            padding: 0px 0px 12px 0px;
        }

        .row>* {
            margin-top: 0px;
        }

        .thumb-wrapper {
            border-radius: 28px 28px 0px 0px;
        }

        .collection-img0 {
            .thumb-wrapper img {
                height: 276px !important;
                object-fit: cover !important;
                width: stretch;
            }
        }
        
        .collection-img1 {
            .thumb-wrapper img {
                height: 276px !important;
                object-fit: cover !important;
            }
        }

        .collection-img2 {
            display: flex;
            flex-wrap: wrap;
            gap: 10px 0px;

            .thumb-wrapper img {
                height: 133px !important;
                width: 100% !important;
                object-fit: cover !important;
            }
        }

        .collection-img3 {
            display: flex;
            flex-wrap: wrap;
            gap: 10px 0px;

            .thumb-wrapper img {
                height: 133px !important;
                width: 100% !important;
                object-fit: cover !important;
            }
        }

        .collection-img4 {
            display: flex;
            flex-wrap: wrap;
            gap: 10px 0px;

            .thumb-wrapper img {
                height: 133px !important;
                width: 100% !important;
                object-fit: cover !important;
            }

            .overlay {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: rgba(0,0,0,0.5);
                color: white;
                font-weight: bold;
                font-size: 2rem;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 4px;
                z-index: 9;
            }
        }
    }

    .card-header {
        display: flex;
        justify-content: space-between;
        padding: 12px 24px;
        align-items: center;
        background-color: #F7F6F3 !important;
        border-bottom: 0px !important;

        &:first-child {
            // border-radius: calc(1.25rem - 1px) calc(1.25rem - 1px) 0 0;
            border-radius: 28px;
        }

        .icon-img {
            cursor: pointer;
        }

        .dropdown__content {
            top: 5%
        }
    }

    

    /* White Card Body */
    .card-body {
    background-color: #ffffff;
    border-radius: 28px !important;
    padding: 12px;
    }

    .cards-section {
    padding-top: 24px;
    }

    .card-content {
    display: block;
    }

    .card-content {
    padding: 12px;
    }
    /* Text Content */
    .card-title {
    font-size: 18px;
    font-weight: 700;
    color: #414651;
    margin: 0 0 18px 0;
    }

    .card-description {
    font-size: 14px;
    color: #717680;
    line-height: 20px;
    }

    /* Footer Actions */
    .card-footer {
    display: flex;
    justify-content: space-around;
    padding: 0;
    border: none;
    background-color: white;
    position: absolute;
    bottom: 20px;
    left: 0px;
    right: 0px;
    }

    .footer-btn {
    background: none;
    border: none;
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    line-height: 20px;
    font-weight: 600;
    color: #535862;
    cursor: pointer;
    }
</style>